(() => {
  if (window.__motechHalloweenBlood) return;
  window.__motechHalloweenBlood = true;

  const root = document.documentElement;
  const footer = document.querySelector(".motech-footer");
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  if (root.dataset.halloweenBlood !== "true") return;
  if (!(footer instanceof HTMLElement) || reducedMotion.matches) return;

  const canvas = document.createElement("canvas");
  canvas.className = "seasonal-halloween__blood-canvas";
  canvas.setAttribute("aria-hidden", "true");
  footer.append(canvas);

  const context = canvas.getContext("2d");
  if (!context) {
    canvas.remove();
    return;
  }

  const surface = [];
  const droplets = [];
  const pointer = { x: -1000, y: -1000, lastX: -1000, lastY: -1000, active: false };
  let width = 0;
  let height = 0;
  let baseY = 0;
  let pixelRatio = 1;
  let animationFrame = 0;
  let lastTime = performance.now();
  let visible = false;

  const randomBetween = (minimum, maximum) => minimum + Math.random() * (maximum - minimum);
  const clamp = (value, minimum, maximum) => Math.min(maximum, Math.max(minimum, value));

  const surfaceYAt = (x) => {
    if (surface.length < 2) return baseY;
    const position = clamp(x / width, 0, 1) * (surface.length - 1);
    const leftIndex = Math.floor(position);
    const rightIndex = Math.min(surface.length - 1, leftIndex + 1);
    const progress = position - leftIndex;
    return surface[leftIndex].y * (1 - progress) + surface[rightIndex].y * progress;
  };

  const disturbSurface = (x, force, radius = 90) => {
    for (const point of surface) {
      const distance = Math.abs(point.x - x);
      if (distance >= radius) continue;
      const influence = 1 - distance / radius;
      point.velocity += force * influence * influence;
    }
  };

  const createDroplet = (x, velocityX, velocityY) => {
    if (droplets.length >= 42) return;
    droplets.push({
      x: clamp(x + randomBetween(-12, 12), 3, width - 3),
      y: surfaceYAt(x) - randomBetween(1, 5),
      vx: velocityX + randomBetween(-42, 42),
      vy: velocityY - randomBetween(40, 110),
      radius: randomBetween(2.4, 6.4),
      stretch: randomBetween(1.1, 1.9),
      shade: Math.random() > 0.35 ? "#a90818" : "#68030c"
    });
  };

  const resize = () => {
    const bounds = canvas.getBoundingClientRect();
    width = Math.max(1, bounds.width);
    height = Math.max(1, bounds.height);
    baseY = height - (width < 741 ? 92 : 128);
    pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(width * pixelRatio);
    canvas.height = Math.round(height * pixelRatio);
    context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);

    const pointCount = clamp(Math.round(width / 20), 36, 88);
    surface.length = 0;
    for (let index = 0; index < pointCount; index += 1) {
      const progress = index / (pointCount - 1);
      surface.push({
        x: progress * width,
        y: baseY + Math.sin(progress * Math.PI * 7) * 4 + randomBetween(-3, 3),
        velocity: 0
      });
    }
  };

  const updateSurface = (delta) => {
    const accelerations = surface.map((point, index) => {
      const left = surface[Math.max(0, index - 1)];
      const right = surface[Math.min(surface.length - 1, index + 1)];
      const spring = (baseY - point.y) * 32;
      const neighbourPull = (left.y + right.y - point.y * 2) * 84;
      return spring + neighbourPull;
    });

    for (let index = 0; index < surface.length; index += 1) {
      const point = surface[index];
      point.velocity += accelerations[index] * delta;
      point.velocity *= Math.pow(0.91, delta * 60);
      point.y += point.velocity * delta;
      point.y = clamp(point.y, baseY - 58, baseY + 42);
    }
  };

  const updateDroplets = (delta) => {
    for (let index = droplets.length - 1; index >= 0; index -= 1) {
      const droplet = droplets[index];

      if (pointer.active) {
        const deltaX = droplet.x - pointer.x;
        const deltaY = droplet.y - pointer.y;
        const distance = Math.hypot(deltaX, deltaY) || 1;
        if (distance < 70) {
          const force = (1 - distance / 70) * 520 * delta;
          droplet.vx += deltaX / distance * force;
          droplet.vy += deltaY / distance * force;
        }
      }

      droplet.vy += 410 * delta;
      droplet.vx *= Math.pow(0.992, delta * 60);
      droplet.x += droplet.vx * delta;
      droplet.y += droplet.vy * delta;

      const liquidY = surfaceYAt(droplet.x);
      if (droplet.y + droplet.radius >= liquidY && droplet.vy > 0) {
        disturbSurface(droplet.x, Math.min(180, droplet.vy * 0.38), 54);
        droplets.splice(index, 1);
      } else if (droplet.x < -20 || droplet.x > width + 20 || droplet.y > height + 20) {
        droplets.splice(index, 1);
      }
    }
  };

  const traceSurface = (verticalOffset = 0) => {
    context.beginPath();
    context.moveTo(0, height);
    context.lineTo(0, surface[0].y + verticalOffset);
    for (let index = 1; index < surface.length - 1; index += 1) {
      const point = surface[index];
      const next = surface[index + 1];
      context.quadraticCurveTo(point.x, point.y + verticalOffset, (point.x + next.x) / 2, (point.y + next.y) / 2 + verticalOffset);
    }
    const last = surface[surface.length - 1];
    context.lineTo(last.x, last.y + verticalOffset);
    context.lineTo(width, height);
    context.closePath();
  };

  const draw = () => {
    context.clearRect(0, 0, width, height);

    traceSurface(13);
    context.fillStyle = "#320006";
    context.fill();

    traceSurface();
    const poolGradient = context.createLinearGradient(0, baseY - 22, 0, height);
    poolGradient.addColorStop(0, "#a90818");
    poolGradient.addColorStop(0.26, "#79050f");
    poolGradient.addColorStop(1, "#2b0005");
    context.fillStyle = poolGradient;
    context.fill();

    context.beginPath();
    context.moveTo(surface[0].x, surface[0].y);
    for (let index = 1; index < surface.length - 1; index += 1) {
      const point = surface[index];
      const next = surface[index + 1];
      context.quadraticCurveTo(point.x, point.y, (point.x + next.x) / 2, (point.y + next.y) / 2);
    }
    context.strokeStyle = "rgba(238, 45, 60, 0.64)";
    context.lineWidth = 2.2;
    context.stroke();

    for (const droplet of droplets) {
      context.save();
      context.translate(droplet.x, droplet.y);
      context.rotate(Math.atan2(droplet.vy, droplet.vx) - Math.PI / 2);
      context.fillStyle = droplet.shade;
      context.beginPath();
      context.ellipse(0, 0, droplet.radius, droplet.radius * droplet.stretch, 0, 0, Math.PI * 2);
      context.fill();
      context.restore();
    }
  };

  const animate = (now) => {
    const delta = Math.min((now - lastTime) / 1000, 0.033);
    lastTime = now;
    updateSurface(delta);
    updateDroplets(delta);
    draw();
    animationFrame = requestAnimationFrame(animate);
  };

  const start = () => {
    if (animationFrame || document.hidden || !visible) return;
    lastTime = performance.now();
    animationFrame = requestAnimationFrame(animate);
  };

  const stop = () => {
    cancelAnimationFrame(animationFrame);
    animationFrame = 0;
  };

  const updatePointer = (event) => {
    const bounds = canvas.getBoundingClientRect();
    const nextX = event.clientX - bounds.left;
    const nextY = event.clientY - bounds.top;
    const deltaX = pointer.active ? nextX - pointer.x : 0;
    const deltaY = pointer.active ? nextY - pointer.y : 0;
    pointer.lastX = pointer.x;
    pointer.lastY = pointer.y;
    pointer.x = nextX;
    pointer.y = nextY;
    pointer.active = nextX >= 0 && nextX <= bounds.width && nextY >= 0 && nextY <= bounds.height;
    if (!pointer.active) return;

    const liquidY = surfaceYAt(nextX);
    if (Math.abs(nextY - liquidY) < 78) {
      const direction = nextY < liquidY ? 1 : -1;
      disturbSurface(nextX, deltaY * 8 + direction * Math.min(120, Math.abs(deltaX) * 2.5), 100);

      const speed = Math.hypot(deltaX, deltaY);
      if (speed > 5 && droplets.length < 42) {
        const count = Math.min(3, Math.ceil(speed / 18));
        for (let index = 0; index < count; index += 1) {
          createDroplet(nextX, deltaX * 7, -Math.min(230, 70 + speed * 5));
        }
      }
    }
  };

  const clearPointer = () => {
    pointer.active = false;
  };

  const resizeObserver = new ResizeObserver(resize);
  resizeObserver.observe(canvas);
  const intersectionObserver = new IntersectionObserver(([entry]) => {
    visible = entry.isIntersecting;
    if (visible) start();
    else stop();
  }, { rootMargin: "180px" });
  intersectionObserver.observe(footer);

  window.addEventListener("pointermove", updatePointer, { passive: true });
  window.addEventListener("pointerout", clearPointer, { passive: true });
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) stop();
    else start();
  });

  resize();
  draw();
})();
